import React from 'react';
import { UserDropdownDto } from '../../types';
import { MultiEmployeeTypeahead } from '../../components/brg/MultiEmployeeTypeahead';

export const MAX_TASK_ASSIGNEES = 5;
export const MAX_TASK_ASSIGNEES_MESSAGE = 'A maximum of 5 users can be assigned to a task.';

interface TaskAssigneesFieldProps {
  value: UserDropdownDto[];
  onChange: (users: UserDropdownDto[]) => void;
  /** Project's BRG — the type-ahead only offers active members of this BRG. */
  brgId?: number;
  disabled?: boolean;
  labelStyle?: React.CSSProperties;
}

/**
 * Multi-user "Assigned To" field for project tasks (Create Task / Edit Task).
 * Same chip + type-ahead pattern as the leadership role fields on the BRG form,
 * limited to MAX_TASK_ASSIGNEES users, with already-assigned users left out of the list.
 */
export function TaskAssigneesField({ value, onChange, brgId, disabled, labelStyle }: TaskAssigneesFieldProps) {
  return (
    <MultiEmployeeTypeahead
      label="Assigned To"
      value={value}
      onChange={onChange}
      brgId={brgId}
      maxSelections={MAX_TASK_ASSIGNEES}
      maxReachedMessage={MAX_TASK_ASSIGNEES_MESSAGE}
      hideSelected
      placeholder="Search and select users..."
      disabled={disabled}
      labelStyle={labelStyle}
    />
  );
}
